type IconProps = {
  className?: string;
};

export const NewMoreIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0006 3.125C8.11751 3.125 6.59131 4.65777 6.59131 6.54891V7.11957C6.59131 9.01071 8.11751 10.5435 10.0006 10.5435C11.8836 10.5435 13.4098 9.01071 13.4098 7.11957V6.54891C13.4098 4.65777 11.8836 3.125 10.0006 3.125ZM9.99945 12.2554C7.7232 12.2554 4.80262 13.4919 3.96224 14.5893C3.44289 15.2678 3.93728 16.25 4.78902 16.25H15.211C16.0627 16.25 16.5571 15.2678 16.0378 14.5893C15.1974 13.4925 12.2757 12.2554 9.99945 12.2554Z"
      fill="currentColor"
    />
  </svg>
);
